import React, { useContext, useEffect, useRef, useState } from "react";
import { Title } from "../../../../../stories/Title/Title";
import Close from "../../../../../images/Close.svg";
import { Tab, Tabs, TextField } from "@mui/material";
import { a11yProps, TabPanel } from "../../../../../styles/Tabs";
import { Label } from "../../../../../stories/Label/Label";
import JunctionsAutocomplete from "../../../../../customComponents/JunctionsAutocomplete";
import { useLazyQuery, useMutation } from "@apollo/client";
import { getJucntionWiseCustomerAndSoOn } from "../../masters/items/queries/queries";
import { Junction } from "../../masters/subsidary/junctions/queries/types";
import { nodeVar, OrderDirection } from "../../../../../utils/commonQueryTypes";
import Modal from "react-modal";
import {
  empType,
  ItemDetailsQueryType,
  Operation,
} from "../../../../../utils/Enum.types";
import JunctionDetails from "../../maps/ticketing/junctionDetails/JunctionDetails";
import { TableType } from "../../../customer/companies/queries/types";
import { MapsContext } from "../../maps/context/context";
import { mapsPayloadType } from "../../maps/context/reducer";
import { Button } from "../../../../../stories/Button/Button";
import {
  EMPTY_STRING,
  emptyFunc,
  emptyMessage,
  ROWS_PER_PAGE,
  TicketStatus,
} from "../../../../../utils/constants";
import TextArea from "../../../../../stories/TextArea/TextArea";
import FileAttach from "../../../../../images/BrowseFiles.svg";
import Upload from "../../../../../images/Upload.svg";
import { AddTicket, GetTickets } from "../../../../../queries/queries";
import {
  AddTicketResult,
  AddTicketVars,
  AtsTicketsOrderField,
  TicketsQueryType,
} from "../../../../../queries/types";
import { msgType } from "../../../../../utils/types";
import Input from "../../../../../stories/Input/Input";
import {
  CustomModal,
  handleMUISelectEvent,
  removeMoreSpace,
  toIsoDate,
} from "../../../../../utils/UtilFunctions";
import useUrlParams from "../../../../../customHooks/useUrlParams";
import useLoggedInUserDetails from "../../../../../customHooks/useLoggedInUserDetails";
import useServerDateandTime from "../../../../../customHooks/useServerDateandTime";
import { handleUploadAndDownloadFile } from "../../../../../utils/Upload";
import LoadingModal from "../../../../pages/LoadingModal";
import useLabels from "../../../../../customHooks/useLabels";
import CompaniesAutocomplete from "../../../customer/companies/CompaniesAutocomplete";
import SubsidiarySelect from "../../../../../customComponents/SubsidiarySelect";
import SiteSelect from "../../../../../customComponents/SiteSelect";

import {
  AddModalStyles,
  ViewRaisedTicketModalStyles,
} from "../../../../../styles/CustomModalStyles";
import { StateTypes } from "../../maps/Maps";
import RaisedTicketDetails from "../../maps/ticketing/junctionDetails/raisedTickets/RaisedTicketDetails";
import { AssetDetailsPageFor } from "../../maps/ticketing/junctionDetails/raisedTickets/AssetDetails";
import { Keys } from "../../../../../utils/Enum.keys";
import MessageModal from "../../../../../customComponents/MessageModal";
import {
  FormAutocomplete,
  formClasses,
} from "../../../../../styles/AutocompleteStyles";
import EmployeeSelect from "../../../../../customComponents/EmplayeeSelect";
import { EmpMaster, EmpQueryType } from "../../users/queries/types";
import { responseType } from "../../../../../utils/formTypes";
import { GetEmpMasterByNodeId } from "../../users/queries/queries";
import { AppContext } from "../../../../../context/context";
import ItemSelect from "../../../../../customComponents/ItemSelect";
import ItemsDetailsAutocomplete from "../../../../../customComponents/ItemsDetailsAutocomplete";
import {
  AtsStckItemDetails,
  ItemQueryType,
} from "../../masters/items/queries/types";
import { GetItemDetatilsByNodeId } from "./queries/queries";
import DataFetch from "../../../../../images/OpenIcon.svg";
import FilterTickets from "./FilterTickets";
import FilterAssetTickets from "./FilterAssetTickets";
import TicketReasonSelect from "../../../../../customComponents/TicketReasonSelect";

interface RaiseTicketModalForm {
  reason: string;
  remarks: string;
}

interface Props {
  setModalFlag: React.Dispatch<React.SetStateAction<boolean>>;
}
interface UserType {
  kgid: number;
  name: string;
  mobile: string;
  designation: string;
}

export interface InstConfigIds {
  companyId: number;
  subId: number;
  siteId: number;
  junctionId: number;
  itemId: number;
  itemDetailsId: number;
}

const RaiseTicket = ({ setModalFlag }: Props) => {
  const [value, setValue] = useState(0);
  const [junctionModalFlag, setJunctionModalFlag] = useState(false);
  const { state, dispatch } = useContext(MapsContext);
  const { state: globalState } = useContext(AppContext);
  const [showRaiseTicketPage, setRaiseTicketPage] = useState(false);
  const [browse, setBrowse] = useState(false);
  const [message, setMessage] = useState<msgType>(emptyMessage);
  const [progress, setProgress] = useState(0);
  const [selectedCompaint, setSelectedCompaint] = useState("");
  const [selectedEmp, setSelectedEmp] = useState<responseType | null>(null);
  const [user, setUser] = useState<UserType>({
    kgid: 0,
    name: "",
    mobile: "",
    designation: "",
  });
  const [assetModalFlag, setAssetModalFlag] = useState(false);

  const [raisedTicketModal, setRaisedTicketModal] = useState<StateTypes>({
    itemId: 0,
    flag: false,
    tableLevel: TableType.COMPANY,
  });

  const [configIds, setConfigIds] = useState<InstConfigIds>({
    companyId: 0,
    subId: 0,
    siteId: 0,
    junctionId: 0,
    itemId: 0,
    itemDetailsId: 0,
  });

  const {
    companyLabel,
    junctionLabel,
    subsidiaryLabel,
    subsidiarySiteLabel,
    itemLabel,
  } = useLabels();

  const { customer_id } = useUrlParams();

  const { serverDate } = useServerDateandTime();

  const [formData, setFormData] = useState<RaiseTicketModalForm>({
    reason: "",
    remarks: "",
  });

  const ref = useRef<HTMLInputElement | null>(null);
  const { user_details } = useLoggedInUserDetails();
  const [assetType, setAssetType] = useState<TableType>(TableType.NONE);
  const [addTicket, { loading }] = useMutation<AddTicketResult, AddTicketVars>(
    AddTicket,
    {
      onError: (e) => {
        setMessage({
          flag: true,
          message: e.message,
          operation: Operation.NONE,
        });
      },
    }
  );

  const handleChange = (event: React.SyntheticEvent, newValue: number) => {
    setRaiseTicketPage(false);
    setValue(newValue);
  };

  const [imageString, setImageString] = useState("");
  const [GetJucntionDetails, { data }] = useLazyQuery<
    { node: Junction },
    nodeVar
  >(getJucntionWiseCustomerAndSoOn);

  const [getItemDetatilsByNodeId, { data: itemDetails }] = useLazyQuery<
    { node: AtsStckItemDetails },
    nodeVar
  >(GetItemDetatilsByNodeId);

  const [GetEmpById, { data: empData, loading: GetEmpMasterByNodeIdLoading }] =
    useLazyQuery<{ node: EmpMaster }, nodeVar>(GetEmpMasterByNodeId);

  const [file, setFile] = useState<FileList | null>(null);

  useEffect(() => {
    if (state.assetTypeId && assetType === TableType.JUNCTION) {
      GetJucntionDetails({
        variables: {
          id: state.assetTypeId,
        },
      });
    }
  }, [state.assetTypeId, GetJucntionDetails]);

  useEffect(() => {
    if (data && data.node && data.node?.icon) {
      const img = require(`../../../../../images/ItemIcons/${data.node.icon}.svg`);

      setImageString(img);
    } else {
      const img = require(`../../../../../images/ItemIcons/junction.svg`);
      setImageString(img);
    }
  }, [data]);

  const handleClear = () => {
    if (showRaiseTicketPage) {
      setFormData({
        reason: "",
        remarks: "",
      });
    } else {
      setConfigIds({
        ...configIds,
        companyId: 0,
        subId: 0,
        siteId: 0,
        junctionId: 0,
      });
      dispatch({
        type: mapsPayloadType.ASSET_TYPE_ID,
        payload: {
          assetTypeId: 0,
        },
      });
    }
    setAssetType(TableType.NONE);
    setConfigIds({
      ...configIds,
      itemId: 0,
      itemDetailsId: 0,
    });
    setSelectedCompaint("");
    setRaiseTicketPage(false);
  };

  const handleImagePreview = (e: React.ChangeEvent<HTMLInputElement>) => {
    if (e.target.files) {
      let image_as_files = e.target.files;
      setFile(image_as_files);
    }
  };

  useEffect(() => {
    dispatch({
      type: mapsPayloadType.ASSET_TYPE_ID,
      payload: {
        assetTypeId: 0,
      },
    });
  }, []);

  const handleAddTicket = async () => {
    try {
      // if (!state.asset) {
      //   setMessage({
      //     flag: true,
      //     message: `${itemLabel} Details not found`,
      //     operation: Operation.NONE,
      //   });
      //   return;
      // }

      // if (!file) {
      //   setMessage({
      //     flag: true,
      //     message: "Attachment is required",
      //     operation: Operation.NONE,
      //   });
      //   return;
      // }
      if (
        formData.reason === EMPTY_STRING ||
        formData.remarks === EMPTY_STRING
      ) {
        setMessage({
          flag: true,
          message:
            formData.reason === EMPTY_STRING
              ? "Reason is required"
              : "Remarks is required",
          operation: Operation.NONE,
        });
        return;
      }

      let filename = "";
      let companyId = 0;
      if (
        file &&
        file.length &&
        ((data && data.node) || (itemDetails && itemDetails.node))
      ) {
        const files = Object.values(file!);

        if (data && data.node) {
          companyId = data.node.companyID;
        } else if (itemDetails && itemDetails.node) {
          companyId = itemDetails?.node.curCompanyID;
        }
        if (companyId)
          filename = files
            ? files.length > 1
              ? files.reduce((acc, itm) => {
                  const seperators = itm.name.split("/");

                  const filename = seperators[seperators.length - 1];

                  acc = acc
                    ? `${acc};${companyId}/ticketDetails/${filename}`
                    : `${companyId}/ticketDetails/${filename}`;
                  return acc;
                }, EMPTY_STRING)
              : `${companyId}/ticketDetails/${
                  files[0].name.split("/")[files[0].name.split("/").length - 1]
                }`
            : EMPTY_STRING;
      }

      if (customer_id) {
        const addedPromise = addTicket({
          variables: {
            customerID: customer_id,
            user_details,
            loggedBy:
              selectedEmp && globalState.empSubType === empType.HELP_DESK
                ? selectedEmp.value
                : 0,
            input: {
              itemDetailsID:
                assetType === TableType.ASSET ? configIds.itemDetailsId : 0,
              reason: formData.reason,
              ticketDate: toIsoDate(serverDate),
              remarks: formData.remarks,
              type: "",
              poleNum: 0,
              junctionID: state.assetTypeId ? state.assetTypeId : 0,
              siteID: 0,
              tableLevel: assetType,
              imagesPath: file ? filename : EMPTY_STRING,
            },
            // Add other necessary variables here
          },
          refetchQueries: [
            {
              query: GetTickets,
              variables: {
                after: null,
                first: ROWS_PER_PAGE,
                name: EMPTY_STRING,
                orderBy: {
                  direction: OrderDirection.ASC,
                  field: AtsTicketsOrderField.TICKET_NO,
                },

                companyID: 0,
                customerID: customer_id,
                subsidiaryID: 0,
                junctionID: 0,
                reason: EMPTY_STRING,
                input: {
                  itemID: 0,
                  ldgrID: 0,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckSubCategoryID: 0,
                  stckUomID: 0,
                  query_type: TicketsQueryType.ALL,
                  itemDetailsID: 0,
                  status: [
                    TicketStatus.ASSIGNED,
                    TicketStatus.OPEN,
                    TicketStatus.RESOLVED,
                    TicketStatus.RE_OPENED,
                  ],
                  empID: user_details.id!,
                  priority: [],
                },
                siteID: 0,
              },
            },
          ],
        });
        addedPromise.then(({ data: promiseData }) => {
          if (promiseData && promiseData.AddTicket) {
            if (file) {
              const files = Object.values(file!);

              const uploadFilePromise = file
                ? Promise.all(
                    files.map((f, index) =>
                      handleUploadAndDownloadFile(
                        f,
                        file.length > 1
                          ? `${companyId}/ticketDetails/${
                              promiseData.AddTicket.ticketDetails[0].id
                            }_${index}.${
                              f.name.split(".")[f.name.split(".").length - 1]
                            }`
                          : `${companyId}/ticketDetails/${
                              promiseData.AddTicket.ticketDetails[0].id
                            }_0.${
                              f.name.split(".")[f.name.split(".").length - 1]
                            }`,
                        setProgress,
                        false
                      )
                    )
                  )
                : false;
              Promise.all([addedPromise, uploadFilePromise]).then(
                ([sendMsgData]) => {
                  if (sendMsgData) {
                    setFile(null);
                    setMessage({
                      flag: true,
                      message: `Ticket Raised Successfully Ticket No : ${promiseData.AddTicket.ticketNo}`,
                      operation: Operation.CREATE,
                    });
                  }
                }
              );
            } else {
              setMessage({
                flag: true,
                message: `Ticket Raised Successfully. Ticket No : ${promiseData.AddTicket.ticketNo}`,
                operation: Operation.CREATE,
              });
            }
          }
        });

        // Handle success (e.g., show a success message, close modal, etc.)
      }

      // else {
      //   setMessage({
      //     flag: true,
      //     message: "Attachment is required",
      //     operation: Operation.NONE,
      //   });
      // }
    } catch (err) {
      console.error(err);
    }
  };

  const handleClose = () => {
    if (message.operation !== Operation.NONE) {
      handleClear();
    }
    setMessage(emptyMessage);
    if (message.operation === Operation.CREATE) {
      setModalFlag(false);
    }
  };

  useEffect(() => {
    if (selectedEmp?.value) {
      GetEmpById({
        variables: {
          id: selectedEmp?.value ? selectedEmp?.value : 0,
        },
      }).then(({ data }) => {
        if (data && data.node) {
          setUser({
            kgid: data.node?.kgid,
            name: data.node?.name,
            mobile: data.node?.mobile,
            designation: data.node?.empType,
          });
        }
      });
    }
  }, [GetEmpById, selectedEmp?.value]);

  useEffect(() => {
    if (state.assetTypeId && assetType === TableType.ASSET) {
      getItemDetatilsByNodeId({
        variables: {
          id: configIds.itemDetailsId,
        },
      });
    }
  }, [getItemDetatilsByNodeId, state.assetTypeId]);

  useEffect(() => {
    setSelectedEmp(null);
    setUser({
      kgid: 0,
      name: "",
      mobile: "",
      designation: "",
    });
  }, [selectedCompaint, assetType]);

  const selectUser = () => {
    return (
      <div>
        {selectedCompaint === "Police" && (
          <div className="label-grid">
            <Label>Metal No / KgId</Label>
            <EmployeeSelect
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedEmp(newValue);
                } else {
                  setSelectedEmp(null);
                }
              }}
              empType={[
                empType.ACP,
                empType.ASI,
                empType.DCP,
                empType.JCP,
                empType.PC,
                empType.PSI,
                empType.WPC,
                empType.WPSI,
                empType.HC,
                empType.WHC,
                empType.WASI,
                empType.PMU
              ]}
              onKeyDown={emptyFunc}
              queryType={EmpQueryType.BY_TYPE}
              value={selectedEmp ? selectedEmp.value : 0}
              label=""
              ldgrId={0}
              kgid={true}
            />
          </div>
        )}

        <div className="label-grid">
          <Label>Name</Label>
          {selectedCompaint === "Vendor" ? (
            <EmployeeSelect
              onChange={(newValue) => {
                if (newValue) {
                  setSelectedEmp(newValue);
                } else {
                  setSelectedEmp(null);
                }
              }}
              empType={[empType.VENDOR_MANAGER]}
              onKeyDown={emptyFunc}
              queryType={EmpQueryType.BY_TYPE}
              value={selectedEmp ? selectedEmp.value : 0}
              label=""
              ldgrId={0}
            />
          ) : (
            <Input value={user.name} disabled />
          )}
        </div>
        <div className="label-grid">
          <Label>Designation</Label>
          <Input value={user.designation} disabled />
        </div>
        <div className="label-grid">
          <Label>Mobile No</Label>
          <Input value={user.mobile} disabled />
        </div>
      </div>
    );
  };

  return (
    <div className="search_ticket">
      <div className="search_ticket__title">
        <Title>Search Details</Title>
        <img
          src={Close}
          alt=""
          onClick={() => {
            setModalFlag(false);
          }}
        />
      </div>

      <div className="search_ticket__tabs">
        <Tabs value={value} onChange={handleChange}>
          <Tab
            label={junctionLabel}
            value={0}
            {...a11yProps(0)}
            onClick={() => {
              handleClear();
            }}
          />

          {/* <Tab label="Filter" value={1} {...a11yProps(1)} /> */}
          <Tab
            label={itemLabel}
            value={2}
            {...a11yProps(2)}
            onClick={() => {
              handleClear();
            }}
          />
        </Tabs>
      </div>

      <div className="search_ticket__junction_detail">
        <TabPanel value={value} index={0}>
          {showRaiseTicketPage ? null : (
            <div className="label-grid">
              <Label>{junctionLabel}</Label>
              <div className="d-flex">
                <JunctionsAutocomplete
                  label=""
                  onChange={(newValue) => {
                    if (newValue) {
                      dispatch({
                        type: mapsPayloadType.ASSET_TYPE_ID,
                        payload: {
                          assetTypeId: newValue.node.id,
                        },
                      });
                      setAssetType(TableType.JUNCTION);
                    } else {
                      dispatch({
                        type: mapsPayloadType.ASSET_TYPE_ID,
                        payload: {
                          assetTypeId: 0,
                        },
                      });
                    }
                  }}
                  onKeyDown={emptyFunc}
                  value={state.assetTypeId ? state.assetTypeId : 0}
                  autoFocus={true}
                />
                <img
                  src={DataFetch}
                  alt=""
                  onClick={() => {
                    setJunctionModalFlag(!junctionModalFlag);
                    setAssetType(TableType.JUNCTION);
                  }}
                  className="data-fetch-icon"
                />
              </div>
            </div>
          )}
          <>
            {assetType === TableType.JUNCTION && data && state.assetTypeId ? (
              <>
                <div className="search_ticket__crumbs font-grey">
                  {data.node.company.name} <span>/</span>{" "}
                  {data.node.subsidiary.name} <span>/</span>{" "}
                  {data.node.site.name}
                </div>
                {state.assetTypeId ? (
                  <JunctionDetails
                    assetType={TableType.JUNCTION}
                    viewIcon={true}
                  />
                ) : null}
              </>
            ) : null}

            {showRaiseTicketPage ? (
              <>
                <div className="search_ticket__asset">
                  <div className="search_ticket__asset--form-block">
                    {/* <JunctionDetails pageType={pageType === TableType.JUNCTION ? TableType.JUNCTION   : TableType.ASSET}/> */}
                    <Title>Raise Ticket</Title>
                    <div className="label-grid">
                      <Label>Ticket Reason</Label>

                      {/* <Input
                          onChange={(e) => {
                            setFormData({
                              ...formData,
                              reason: e.target.value,
                            });
                          }}
                          inputRef={ref}
                          value={formData.reason}
                          onKeyDown={(e) => {
                            if (e.key === Keys.ENTER) {
                              const textAreaEle =
                                document.getElementsByTagName(TEXTAREA);

                              if (textAreaEle.length) {
                                (
                                  textAreaEle[0] as HTMLTextAreaElement
                                ).select();
                              }
                            }
                          }}
                          required
                        /> */}

                      <TicketReasonSelect
                        onChange={(newValue) => {
                          if (newValue) {
                            setFormData({
                              ...formData,
                              reason: newValue,
                            });
                          } else {
                            setFormData({
                              ...formData,
                              reason: newValue,
                            });
                          }
                        }}
                        value={formData.reason}
                      />

                      {/* <FormAutocomplete
                            className={formClasses.inputRoot}
                            options={ticketRaiseResonOptions}
                            onKeyDown={(e) => {
                              if (e.key === Keys.ENTER) {
                                const textAreaEle =
                                  document.getElementsByTagName(TEXTAREA);

                                if (textAreaEle.length) {
                                  (
                                    textAreaEle[0] as HTMLTextAreaElement
                                  ).select();
                                }
                              }
                            }}
                            value={formData.reason}
                            openOnFocus
                            forcePopupIcon
                            onChange={(e, newValue) => {
                              if (newValue) {
                                setFormData((prev) => ({
                                  ...prev,
                                  reason: newValue as string,
                                }));
                              } else {
                                setFormData((prev) => ({
                                  ...prev,
                                  reason: "",
                                }));
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label=""
                                // autoFocus={autoFocus}
                                onChange={(e) => {}}
                                className={formClasses.formControlRoot}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                placeholder={"Select"}
                              />
                            )}
                          /> */}
                    </div>
                    <div className="label-grid">
                      <Label>Complaint Description</Label>
                      <TextArea
                        rows={3}
                        name="remarks"
                        value={formData.remarks}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            remarks: e.target.value,
                          });
                        }}
                        required
                      />
                    </div>
                    {globalState.empSubType === empType.HELP_DESK ? (
                      <>
                        <div className="label-grid">
                          <Label>Compaint Given By</Label>
                          <FormAutocomplete
                            className={formClasses.inputRoot}
                            options={["Police", "Vendor", "Others / Public"]}
                            // onKeyDown={onKeyDown}
                            value={selectedCompaint}
                            openOnFocus
                            forcePopupIcon
                            // getOptionLabel={(option) =>
                            //   (option as AtsCompanyEdge).node.name
                            // }
                            // slotProps={{
                            //   listbox: {
                            //     onScroll: handleScroll,
                            //   },
                            // }}
                            onChange={(e, newValue) => {
                              if (newValue) {
                                setSelectedCompaint(newValue as string);
                              } else {
                                setSelectedCompaint("");
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label=""
                                // autoFocus={autoFocus}
                                onChange={(e) => {}}
                                className={formClasses.formControlRoot}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                placeholder={"Select"}
                              />
                            )}
                          />
                        </div>
                        {selectedCompaint === "Police" ||
                        selectedCompaint === "Vendor"
                          ? selectUser()
                          : ""}
                      </>
                    ) : (
                      ""
                    )}

                    <div className="label-grid">
                      <Label>Attachments</Label>
                      <div className="items__add--form--flex">
                        {/* <Input value={file?.name} disabled /> */}
                        {!browse ? (
                          <>
                            <label className="items__add--form--details--browse">
                              <img
                                src={FileAttach}
                                alt="/"
                                className="browse-icon"
                              />
                              Browse
                              <input
                                id="student-documents__browse--inputTag"
                                type="file"
                                className="assignment-creation__fileattach--input"
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleImagePreview(e);
                                  setBrowse(!browse);
                                }}
                                accept="jpg, .png, .jpeg"
                              />
                            </label>{" "}
                          </>
                        ) : (
                          <>
                            <button className="items__add--form--details--upload">
                              <img src={Upload} alt="" />
                              Upload
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {value ? (
                  <>
                    <div className="filter_head">Please Select the filter</div>
                    <div className="label-grid">
                      <Label>{companyLabel}</Label>
                      <CompaniesAutocomplete
                        onChange={(newValue) => {
                          if (newValue) {
                            setConfigIds({
                              ...configIds,
                              companyId: newValue.node.id,
                            });
                          } else {
                            setConfigIds({
                              ...configIds,
                              companyId: 0,
                              subId: 0,
                              siteId: 0,
                              junctionId: 0,
                            });

                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={configIds.companyId}
                        label=""
                      />
                    </div>
                    <div className="label-grid">
                      <Label>{subsidiaryLabel}</Label>
                      <SubsidiarySelect
                        onChange={(newValue) => {
                          if (newValue) {
                            setConfigIds({
                              ...configIds,
                              subId: newValue.node.id,
                            });
                          } else {
                            setConfigIds({
                              ...configIds,
                              subId: 0,
                              siteId: 0,
                              junctionId: 0,
                            });
                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={configIds.subId}
                        companyID={configIds.companyId}
                        label=""
                      />
                    </div>
                    <div className="label-grid">
                      <Label>{subsidiarySiteLabel}</Label>
                      <SiteSelect
                        onChange={(newValue) => {
                          if (newValue) {
                            setConfigIds({
                              ...configIds,
                              siteId: newValue.value,
                            });
                          } else {
                            setConfigIds({
                              ...configIds,
                              siteId: 0,
                              junctionId: 0,
                            });
                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={configIds.siteId}
                        companyId={configIds.companyId}
                        subsidiaryId={configIds.subId}
                        label=""
                      />
                    </div>
                    <div className="label-grid">
                      <Label>{junctionLabel}</Label>
                      <JunctionsAutocomplete
                        onChange={(newValue) => {
                          if (newValue) {
                            setConfigIds({
                              ...configIds,
                              junctionId: newValue.node.id,
                            });
                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: newValue.node.id,
                              },
                            });
                          } else {
                            setConfigIds({
                              ...configIds,
                              junctionId: 0,
                            });
                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={configIds.junctionId}
                        companyID={configIds.companyId}
                        subsidiaryID={configIds.subId}
                        siteID={configIds.siteId}
                        label=""
                      />
                    </div>
                    {/* <div className="label-grid">
              <Label>{itemLabel}</Label>
              <ItemsAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    setConfigIds({
                      ...configIds,
                      itemId: newValue.value,
                    });
                  } else {
                    setConfigIds({
                      ...configIds,
                      itemId: 0,
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                value={configIds.itemId}
                QueryType={ItemQueryType.All}
                label=""
                placeholder=""
              />
            </div>
            <div className="label-grid">
              <Label>{itemLabel} Details</Label>
              <ItemsDetailsAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    setConfigIds({
                      ...configIds,
                      itemDetailsId: newValue.value,
                    });
                  } else {
                    setConfigIds({
                      ...configIds,
                      itemDetailsId: 0,
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                value={configIds.itemDetailsId}
                input={{
                  query_type: ItemDetailsQueryType.ALL,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckUomID: 0,
                  stckSubCategoryID: 0,
                  itemID: configIds.itemId,
                  ldgrID: 0,
                  poleNum: 0,
                }}
                queryInput={{
                  companyID: configIds.companyId,
                  customerID: customer_id!,
                  junctionID: configIds.junctionId,
                  siteID: configIds.siteId,
                  subsidiaryID: configIds.subId,
                }}
                label=""
              />
            </div> */}
                  </>
                ) : (
                  <>
                    {!data && state.assetTypeId ? (
                      <b className="nodata">Junction details not found</b>
                    ) : (
                      ""
                    )}
                  </>
                )}
              </>
            )}
          </>
        </TabPanel>

        <TabPanel value={value} index={1}>
          <>
            {/* {data && state.assetTypeId ? (
              <>
                <div className="search_ticket__crumbs font-grey">
                  {data.node.company.name} <span>/</span>{" "}
                  {data.node.subsidiary.name} <span>/</span>{" "}
                  {data.node.site.name}
                </div>
                {state.assetTypeId ? (
                  <JunctionDetails
                    assetType={TableType.JUNCTION}
                    viewIcon={true}
                  />
                ) : null}
              </>
            ) : null} */}

            {showRaiseTicketPage ? (
              <>
                <div className="search_ticket__asset">
                  <div className="search_ticket__asset--form-block">
                    {/* <JunctionDetails pageType={pageType === TableType.JUNCTION ? TableType.JUNCTION   : TableType.ASSET}/> */}
                    <Title>Raise Ticket</Title>
                    <div className="label-grid">
                      <Label>Ticket Reason</Label>

                      {/* <Input
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            reason: e.target.value,
                          });
                        }}
                        inputRef={ref}
                        value={formData.reason}
                        onKeyDown={(e) => {
                          if (e.key === Keys.ENTER) {
                            const textAreaEle =
                              document.getElementsByTagName(TEXTAREA);
                            if (textAreaEle.length) {
                              (textAreaEle[0] as HTMLTextAreaElement).select();
                            }
                          }
                        }}
                        required
                      /> */}
                      <TicketReasonSelect
                        onChange={(newValue) => {
                          if (newValue) {
                            setFormData({
                              ...formData,
                              reason: newValue,
                            });
                          } else {
                            setFormData({
                              ...formData,
                              reason: newValue,
                            });
                          }
                        }}
                        value={formData.reason}
                      />
                      {/* <FormAutocomplete
                            className={formClasses.inputRoot}
                            options={ticketRaiseResonOptions}
                            onKeyDown={(e) => {
                              if (e.key === Keys.ENTER) {
                                const textAreaEle =
                                  document.getElementsByTagName(TEXTAREA);

                                if (textAreaEle.length) {
                                  (
                                    textAreaEle[0] as HTMLTextAreaElement
                                  ).select();
                                }
                              }
                            }}
                            value={formData.reason}
                            openOnFocus
                            forcePopupIcon
                            onChange={(e, newValue) => {
                              if (newValue) {
                                setFormData((prev) => ({
                                  ...prev,
                                  reason: newValue as string,
                                }));
                              } else {
                                setFormData((prev) => ({
                                  ...prev,
                                  reason: "",
                                }));
                              }
                            }}
                            renderInput={(params) => (
                              <TextField
                                {...params}
                                fullWidth
                                label=""
                                // autoFocus={autoFocus}
                                onChange={(e) => {}}
                                className={formClasses.formControlRoot}
                                slotProps={{
                                  inputLabel: {
                                    shrink: true,
                                  },
                                }}
                                placeholder={"Select"}
                              />
                            )}
                          /> */}
                    </div>
                    <div className="label-grid">
                      <Label>Complaint Description</Label>
                      <TextArea
                        rows={3}
                        name="remarks"
                        value={formData.remarks}
                        onChange={(e) => {
                          setFormData({
                            ...formData,
                            remarks: e.target.value,
                          });
                        }}
                        required
                      />
                    </div>
                    <div className="label-grid">
                      <Label>Attachments</Label>
                      <div className="items__add--form--flex">
                        {/* <Input value={file?.name} disabled /> */}
                        {!browse ? (
                          <>
                            <label className="items__add--form--details--browse">
                              <img
                                src={FileAttach}
                                alt="/"
                                className="browse-icon"
                              />
                              Browse
                              <input
                                id="student-documents__browse--inputTag"
                                type="file"
                                className="assignment-creation__fileattach--input"
                                onChange={(
                                  e: React.ChangeEvent<HTMLInputElement>
                                ) => {
                                  handleImagePreview(e);
                                  setBrowse(!browse);
                                }}
                                accept="jpg, .png, .jpeg"
                              />
                            </label>{" "}
                          </>
                        ) : (
                          <>
                            <button className="items__add--form--details--upload">
                              <img src={Upload} alt="" />
                              Upload
                            </button>
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </>
            ) : (
              <>
                {value ? (
                  <>
                    <div className="filter_head">Please Select the filter</div>
                    <div className="label-grid">
                      <Label>{companyLabel}</Label>
                      <CompaniesAutocomplete
                        onChange={(newValue) => {
                          if (newValue) {
                            setConfigIds({
                              ...configIds,
                              companyId: newValue.node.id,
                            });
                          } else {
                            setConfigIds({
                              ...configIds,
                              companyId: 0,
                              subId: 0,
                              siteId: 0,
                              junctionId: 0,
                            });

                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={configIds.companyId}
                        label=""
                      />
                    </div>
                    <div className="label-grid">
                      <Label>{subsidiaryLabel}</Label>
                      <SubsidiarySelect
                        onChange={(newValue) => {
                          if (newValue) {
                            setConfigIds({
                              ...configIds,
                              subId: newValue.node.id,
                            });
                          } else {
                            setConfigIds({
                              ...configIds,
                              subId: 0,
                              siteId: 0,
                              junctionId: 0,
                            });

                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={configIds.subId}
                        companyID={configIds.companyId}
                        label=""
                      />
                    </div>
                    <div className="label-grid">
                      <Label>{subsidiarySiteLabel}</Label>
                      <SiteSelect
                        onChange={(newValue) => {
                          if (newValue) {
                            setConfigIds({
                              ...configIds,
                              siteId: newValue.value,
                            });
                          } else {
                            setConfigIds({
                              ...configIds,
                              siteId: 0,
                              junctionId: 0,
                            });

                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={configIds.siteId}
                        companyId={configIds.companyId}
                        subsidiaryId={configIds.subId}
                        label=""
                      />
                    </div>
                    <div className="label-grid">
                      <Label>{junctionLabel}</Label>
                      <JunctionsAutocomplete
                        onChange={(newValue) => {
                          if (newValue) {
                            setConfigIds({
                              ...configIds,
                              junctionId: newValue.node.id,
                            });
                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: newValue.node.id,
                              },
                            });
                          } else {
                            setConfigIds({
                              ...configIds,
                              junctionId: 0,
                            });
                            dispatch({
                              type: mapsPayloadType.ASSET_TYPE_ID,
                              payload: {
                                assetTypeId: 0,
                              },
                            });
                          }
                        }}
                        onKeyDown={emptyFunc}
                        value={configIds.junctionId}
                        companyID={configIds.companyId}
                        subsidiaryID={configIds.subId}
                        siteID={configIds.siteId}
                        label=""
                      />
                    </div>
                    {/* <div className="label-grid">
              <Label>{itemLabel}</Label>
              <ItemsAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    setConfigIds({
                      ...configIds,
                      itemId: newValue.value,
                    });
                  } else {
                    setConfigIds({
                      ...configIds,
                      itemId: 0,
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                value={configIds.itemId}
                QueryType={ItemQueryType.All}
                label=""
                placeholder=""
              />
            </div>
            <div className="label-grid">
              <Label>{itemLabel} Details</Label>
              <ItemsDetailsAutocomplete
                onChange={(newValue) => {
                  if (newValue) {
                    setConfigIds({
                      ...configIds,
                      itemDetailsId: newValue.value,
                    });
                  } else {
                    setConfigIds({
                      ...configIds,
                      itemDetailsId: 0,
                    });
                  }
                }}
                onKeyDown={emptyFunc}
                value={configIds.itemDetailsId}
                input={{
                  query_type: ItemDetailsQueryType.ALL,
                  stckCategoryID: 0,
                  stckGroupID: 0,
                  stckManufacturerID: 0,
                  stckUomID: 0,
                  stckSubCategoryID: 0,
                  itemID: configIds.itemId,
                  ldgrID: 0,
                  poleNum: 0,
                }}
                queryInput={{
                  companyID: configIds.companyId,
                  customerID: customer_id!,
                  junctionID: configIds.junctionId,
                  siteID: configIds.siteId,
                  subsidiaryID: configIds.subId,
                }}
                label=""
              />
            </div> */}
                  </>
                ) : (
                  <>
                    {data ? (
                      <></>
                    ) : (
                      <b className="nodata">Junction details not found</b>
                    )}
                  </>
                )}
              </>
            )}
          </>
        </TabPanel>
        <TabPanel
          value={value}
          // index={globalState.empSubType !== empType.VENDOR_MANAGER ? 2 : 0}
          index={2}
        >
          <>
            <div>
              <div className="label-grid">
                <Label>{itemLabel}</Label>
                <ItemSelect
                  onChange={(newValue) => {
                    if (newValue) {
                      setConfigIds({
                        ...configIds,
                        itemId: newValue.value,
                      });
                    } else {
                      setConfigIds({
                        ...configIds,
                        itemId: 0,
                      });
                    }
                  }}
                  onKeyDown={(e) => {
                    if (e.key === Keys.ENTER) {
                      e.preventDefault();
                      handleMUISelectEvent(e);
                    }
                  }}
                  value={configIds.itemId}
                  placeholder=""
                  isComponent={false}
                  QueryType={ItemQueryType.ITEMS_ASSOIC_LDGR}
                />
              </div>
              <div className="label-grid">
                <Label>{itemLabel} Details</Label>
                <div className="d-flex">
                  <ItemsDetailsAutocomplete
                    onChange={(newValue) => {
                      if (newValue) {
                        setConfigIds({
                          ...configIds,
                          itemDetailsId: newValue.value,
                        });
                        dispatch({
                          type: mapsPayloadType.ASSET_TYPE_ID,
                          payload: { assetTypeId: newValue.value },
                        });

                        setRaiseTicketPage(true);
                        setAssetType(TableType.ASSET);
                      } else {
                        setConfigIds({
                          ...configIds,
                          itemDetailsId: 0,
                        });
                        dispatch({
                          type: mapsPayloadType.ASSET_TYPE_ID,
                          payload: { assetTypeId: 0 },
                        });
                      }
                    }}
                    onKeyDown={emptyFunc}
                    value={configIds.itemDetailsId}
                    input={{
                      query_type: ItemDetailsQueryType.ALL,
                      stckCategoryID: 0,
                      stckGroupID: 0,
                      stckManufacturerID: 0,
                      stckUomID: 0,
                      stckSubCategoryID: 0,
                      itemID: configIds.itemId,
                      ldgrID: 0,
                      poleNum: 0,
                      empID: user_details.id!,
                    }}
                    queryInput={{
                      companyID: configIds.companyId,
                      customerID: customer_id!,
                      junctionID: configIds.junctionId,
                      siteID: configIds.siteId,
                      subsidiaryID: configIds.subId,
                    }}
                    label=""
                  />
                  <img
                    src={DataFetch}
                    alt=""
                    onClick={() => {
                      setAssetModalFlag(!assetModalFlag);
                    }}
                    className="data-fetch-icon"
                  />
                </div>
              </div>
              {assetType === TableType.ASSET &&
              itemDetails &&
              state.assetTypeId ? (
                <>
                  <div className="search_ticket__crumbs font-grey">
                    {itemDetails.node?.currentCompany?.name} <span>/</span>{" "}
                    {itemDetails.node?.currentSubsidiary?.name} <span>/</span>{" "}
                    {itemDetails.node?.currentSite?.name}
                  </div>

                  {state.assetTypeId ? (
                    <JunctionDetails
                      assetType={TableType.ASSET}
                      viewIcon={true}
                    />
                  ) : null}
                </>
              ) : null}
              <div>
                {showRaiseTicketPage &&
                itemDetails &&
                itemDetails.node.ticketStatus !== TicketStatus.OPEN ? (
                  <>
                    <div className="search_ticket__asset">
                      <div className="search_ticket__asset--form-block">
                        {/* <JunctionDetails pageType={pageType === TableType.JUNCTION ? TableType.JUNCTION   : TableType.ASSET}/> */}
                        <Title>Raise Ticket</Title>
                        <div className="label-grid">
                          <Label>Ticket Reason</Label>
                          <Input
                            id=""
                            type="text"
                            onChange={(
                              e: React.ChangeEvent<HTMLInputElement>
                            ) => {
                              setFormData({
                                ...formData,
                                reason: e.target.value,
                              });
                            }}
                            value={formData.reason}
                          />
                        </div>
                        <div className="label-grid">
                          <Label>Complaint Description</Label>
                          <TextArea
                            rows={3}
                            name="remarks"
                            value={formData.remarks}
                            onChange={(e) => {
                              setFormData({
                                ...formData,
                                remarks: e.target.value,
                              });
                            }}
                            required
                          />
                        </div>
                        {globalState.empSubType === empType.HELP_DESK ? (
                          <>
                            <div className="label-grid">
                              <Label>Compaint Given By</Label>
                              <FormAutocomplete
                                className={formClasses.inputRoot}
                                options={[
                                  "Police",
                                  "Vendor",
                                  "Others / Public",
                                ]}
                                onKeyDown={emptyFunc}
                                value={selectedCompaint}
                                openOnFocus
                                forcePopupIcon
                                // getOptionLabel={(option) =>
                                //   (option as AtsCompanyEdge).node.name
                                // }
                                // slotProps={{
                                //   listbox: {
                                //     onScroll: handleScroll,
                                //   },
                                // }}
                                onChange={(e, newValue) => {
                                  if (newValue) {
                                    setSelectedCompaint(newValue as string);
                                  } else {
                                    setSelectedCompaint("");
                                  }
                                }}
                                renderInput={(params) => (
                                  <TextField
                                    {...params}
                                    fullWidth
                                    label=""
                                    // autoFocus={autoFocus}
                                    onChange={(e) => {}}
                                    className={formClasses.formControlRoot}
                                    slotProps={{
                                      inputLabel: {
                                        shrink: true,
                                      },
                                    }}
                                    placeholder={"Select"}
                                  />
                                )}
                              />
                            </div>
                            {selectedCompaint === "Police" ||
                            selectedCompaint === "Vendor"
                              ? selectUser()
                              : ""}
                          </>
                        ) : (
                          ""
                        )}

                        <div className="label-grid">
                          <Label>Attachments</Label>
                          <div className="items__add--form--flex">
                            {/* <Input value={file?.name} disabled /> */}
                            {!browse ? (
                              <>
                                <label className="items__add--form--details--browse">
                                  <img
                                    src={FileAttach}
                                    alt="/"
                                    className="browse-icon"
                                  />
                                  Browse
                                  <input
                                    id="student-documents__browse--inputTag"
                                    type="file"
                                    className="assignment-creation__fileattach--input"
                                    onChange={(
                                      e: React.ChangeEvent<HTMLInputElement>
                                    ) => {
                                      handleImagePreview(e);
                                      setBrowse(!browse);
                                    }}
                                    accept="jpg, .png, .jpeg"
                                  />
                                </label>{" "}
                              </>
                            ) : (
                              <>
                                <button className="items__add--form--details--upload">
                                  <img src={Upload} alt="" />
                                  Upload
                                </button>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                    </div>
                  </>
                ) : (
                  ""
                )}
              </div>
            </div>
          </>
        </TabPanel>
      </div>

      {assetType === TableType.JUNCTION && data && state.assetTypeId ? (
        data.node.ticketStatus === TicketStatus.OPEN ? (
          <Button
            mode="view"
            onClick={() => {
              setRaisedTicketModal({
                flag: true,
                itemId: 0,
                tableLevel: TableType.JUNCTION,
              });
            }}
          >
            {" "}
            Ticket Details
          </Button>
        ) : (
          <Button
            mode="raise"
            onClick={() => {
              if (showRaiseTicketPage) {
                handleAddTicket();
              } else setRaiseTicketPage(true);
            }}
            disabled={
              showRaiseTicketPage &&
              formData.remarks === removeMoreSpace(EMPTY_STRING)
            }
          >
            Ticket
          </Button>
        )
      ) : null}
      {assetType === TableType.ASSET && itemDetails && itemDetails.node ? (
        itemDetails.node.ticketStatus === TicketStatus.OPEN ? (
          <Button
            mode="view"
            onClick={() => {
              setRaisedTicketModal({
                flag: true,
                itemId: 0,
                tableLevel: TableType.ASSET,
              });
            }}
          >
            {" "}
            Ticket Details
          </Button>
        ) : (
          <Button
            mode="raise"
            onClick={() => {
              if (showRaiseTicketPage) {
                handleAddTicket();
              } else setRaiseTicketPage(true);
            }}
          >
            Ticket
          </Button>
        )
      ) : null}

      <Button mode="clear" onClick={handleClear} />
      <Button
        mode="cancel"
        onClick={() => {
          if (showRaiseTicketPage) setRaiseTicketPage(false);
          else setModalFlag(false);
        }}
      />
      <LoadingModal flag={loading} />
      <CustomModal
        style={ViewRaisedTicketModalStyles}
        isOpen={raisedTicketModal.flag}
        onRequestClose={() =>
          setRaisedTicketModal({
            flag: false,
            itemId: 0,
            tableLevel: TableType.COMPANY,
          })
        }
        contentComponent={
          <RaisedTicketDetails
            setModalFlag={() =>
              setRaisedTicketModal({
                flag: false,
                itemId: 0,
                tableLevel: TableType.CUSTOMER,
              })
            }
            assetType={assetType}
            pageFor={AssetDetailsPageFor.MAPS}
            itemsView={false}
          />
        }
      />

      <Modal
        isOpen={junctionModalFlag}
        ariaHideApp={false}
        style={AddModalStyles}
      >
        <FilterTickets
          setRaiseTicketPage={setRaiseTicketPage}
          setModalFlag={setJunctionModalFlag}
          modalFlag={junctionModalFlag}
        />
      </Modal>

      <Modal isOpen={assetModalFlag} ariaHideApp={false} style={AddModalStyles}>
        <FilterAssetTickets
          setModalFlag={setAssetModalFlag}
          setConfigIds={setConfigIds}
          setRaiseTicketPage={setRaiseTicketPage}
          setAssetType={setAssetType}
          configIds={configIds}
        />
      </Modal>

      <MessageModal
        handleClose={handleClose}
        modalFlag={message.flag}
        operation={message.operation}
        value={message.message}
      />
    </div>
  );
};

export default RaiseTicket;
